import { EXPERIENCE_PLAYER_BASE_URL } from './constants'

async function handleResponse(response) {
  if (!response.ok) {
    const body = await response.json().catch(() => ({}))
    const error = new Error(
      body.message || `Request failed: ${response.status}`,
    )
    error.statusCode = response.status
    error.code = body.code
    error.details = body.details
    throw error
  }
  return response.json()
}

export async function createLink({ lessonId, ttlSeconds, generatePassword }) {
  const body = { lessonId }
  if (ttlSeconds != null) body.ttlSeconds = ttlSeconds
  if (generatePassword != null) body.generatePassword = generatePassword

  const response = await fetch(`${EXPERIENCE_PLAYER_BASE_URL}/admin/links`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })

  return handleResponse(response)
}

export async function getLinkDetails({ linkId }) {
  const response = await fetch(
    `${EXPERIENCE_PLAYER_BASE_URL}/admin/links/${encodeURIComponent(linkId)}`,
  )

  return handleResponse(response)
}
